import { createContext } from 'react';

const sampleContext = createContext();

export default sampleContext;